var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLevelBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25987 1.75635C8.76534 0.346002 11.1547 0.346002 12.6602 1.75635C13.2686 2.3263 14.0565 2.68726 14.8862 2.76871L15.2812 2.80749C17.1899 2.99486 18.5638 4.73832 18.3186 6.6404C18.2132 7.45852 18.4131 8.29232 18.8812 8.97153C19.9916 10.5828 19.4877 12.7991 17.7897 13.7717L17.6351 13.8602C16.9219 14.2688 16.3747 14.9148 16.0891 15.6855L16.0715 15.7332C15.389 17.5749 13.371 18.5459 11.506 17.9298L11.2068 17.831C10.3971 17.5636 9.52292 17.5636 8.71326 17.831L8.41407 17.9298C6.54904 18.5459 4.53103 17.5749 3.84856 15.7332L3.83091 15.6855C3.54531 14.9148 2.99816 14.2688 2.28492 13.8602L2.13039 13.7717C0.432369 12.7991 -0.0715834 10.5828 1.03889 8.97153C1.50699 8.29232 1.70686 7.45852 1.60141 6.6404C1.35624 4.73832 2.73017 2.99486 4.63881 2.80749L5.03388 2.76871C5.86355 2.68726 6.65148 2.3263 7.25987 1.75635Z",
    fill: "url(#paint0_linear_252_667)",
    stroke: "white",
    strokeWidth: 0.233305
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_667",
    x1: 1.58437,
    y1: 3.56864,
    x2: 15.8495,
    y2: 19.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4642E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA14E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLevelBg);
export default __webpack_public_path__ + "static/media/icon-level-bg.8f28a7b0958928cc36ea2b0fec1736ba.svg";
export { ForwardRef as ReactComponent };